import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/layout/layout"
import Image1 from "../../static/images/image_1.jpg"
import Image2 from "../../static/images/image_2.jpg"
import Image3 from "../../static/images/image_3.jpg"
import Image4 from "../../static/images/image_4.jpg"
import Image5 from "../../static/images/image_5.jpg"
import Image6 from "../../static/images/image_6.jpg"

function BlogPage() {
  return (
    <Layout>
      <Helmet>
        <title>Junaid Elahi | Blog</title>
      </Helmet>
      <div className="page">
        <div id="colorlib-page">
          <section className="ftco-section">
            <div className="container mt-5">
              <div className="row justify-content-center mb-5 pb-5">
                <div
                  className="col-md-7 text-center heading-section ftco-animate"
                  data-aos="fade-up"
                >
                  <span>Blog</span>
                  <h2>Read our blog</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 ftco-animate" data-aos="fade-up">
                  <div className="blog-entry">
                    <a
                      href="blog-single.html"
                      className="block-20"
                      style={{ backgroundImage: "url(" + Image1 + ")" }}
                    ></a>
                    <div className="text p-4 d-block">
                      <div className="meta mb-3">
                        <div>
                          <a href="#">July 12, 2018</a>
                        </div>
                        <div>
                          <a href="#">Admin</a>
                        </div>
                        <div>
                          <a href="#" className="meta-chat">
                            <span className="icon-chat"></span> 3
                          </a>
                        </div>
                      </div>
                      <h3 className="heading">
                        <a href="#">
                          Even the all-powerful Pointing has no control about
                          the blind texts
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 ftco-animate" data-aos="fade-up">
                  <div className="blog-entry" data-aos-delay="100">
                    <a
                      href="blog-single.html"
                      className="block-20"
                      style={{ backgroundImage: "url(" + Image2 + ")" }}
                    ></a>
                    <div className="text p-4">
                      <div className="meta mb-3">
                        <div>
                          <a href="#">July 12, 2018</a>
                        </div>
                        <div>
                          <a href="#">Admin</a>
                        </div>
                        <div>
                          <a href="#" className="meta-chat">
                            <span className="icon-chat"></span> 3
                          </a>
                        </div>
                      </div>
                      <h3 className="heading">
                        <a href="#">
                          Even the all-powerful Pointing has no control about
                          the blind texts
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 ftco-animate" data-aos="fade-up">
                  <div className="blog-entry" data-aos-delay="200">
                    <a
                      href="blog-single.html"
                      className="block-20"
                      style={{ backgroundImage: "url(" + Image3 + ")" }}
                    ></a>
                    <div className="text p-4">
                      <div className="meta mb-3">
                        <div>
                          <a href="#">July 12, 2018</a>
                        </div>
                        <div>
                          <a href="#">Admin</a>
                        </div>
                        <div>
                          <a href="#" className="meta-chat">
                            <span className="icon-chat"></span> 3
                          </a>
                        </div>
                      </div>
                      <h3 className="heading">
                        <a href="#">
                          Even the all-powerful Pointing has no control about
                          the blind texts
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 ftco-animate" data-aos="fade-up">
                  <div className="blog-entry">
                    <a
                      href="blog-single.html"
                      className="block-20"
                      style={{ backgroundImage: "url(" + Image4 + ")" }}
                    ></a>
                    <div className="text p-4 d-block">
                      <div className="meta mb-3">
                        <div>
                          <a href="#">July 12, 2018</a>
                        </div>
                        <div>
                          <a href="#">Admin</a>
                        </div>
                        <div>
                          <a href="#" className="meta-chat">
                            <span className="icon-chat"></span> 3
                          </a>
                        </div>
                      </div>
                      <h3 className="heading">
                        <a href="#">
                          Even the all-powerful Pointing has no control about
                          the blind texts
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 ftco-animate" data-aos="fade-up">
                  <div className="blog-entry" data-aos-delay="100">
                    <a
                      href="blog-single.html"
                      className="block-20"
                      style={{ backgroundImage: "url(" + Image5 + ")" }}
                    ></a>
                    <div className="text p-4">
                      <div className="meta mb-3">
                        <div>
                          <a href="#">July 12, 2018</a>
                        </div>
                        <div>
                          <a href="#">Admin</a>
                        </div>
                        <div>
                          <a href="#" className="meta-chat">
                            <span className="icon-chat"></span> 3
                          </a>
                        </div>
                      </div>
                      <h3 className="heading">
                        <a href="#">
                          Even the all-powerful Pointing has no control about
                          the blind texts
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 ftco-animate" data-aos="fade-up">
                  <div className="blog-entry" data-aos-delay="200">
                    <a
                      href="blog-single.html"
                      className="block-20"
                      style={{ backgroundImage: "url(" + Image6 + ")" }}
                    ></a>
                    <div className="text p-4">
                      <div className="meta mb-3">
                        <div>
                          <a href="#">July 12, 2018</a>
                        </div>
                        <div>
                          <a href="#">Admin</a>
                        </div>
                        <div>
                          <a href="#" className="meta-chat">
                            <span className="icon-chat"></span> 3
                          </a>
                        </div>
                      </div>
                      <h3 className="heading">
                        <a href="#">
                          Even the all-powerful Pointing has no control about
                          the blind texts
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col text-center">
                  <div className="block-27">
                    <ul>
                      <li>
                        <a href="#">&lt;</a>
                      </li>
                      <li className="active">
                        <span>1</span>
                      </li>
                      <li>
                        <a href="#">2</a>
                      </li>
                      <li>
                        <a href="#">3</a>
                      </li>
                      <li>
                        <a href="#">4</a>
                      </li>
                      <li>
                        <a href="#">5</a>
                      </li>
                      <li>
                        <a href="#">&gt;</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  )
}

export default BlogPage
